export default "__VITE_ASSET___KIX7IgB__"